import { ACTION_TYPES } from "./Actions";

const isLoggedIn = sessionStorage.getItem("cms_isLoggedIn") === "true";

const parsedUserInfo = () => {
	try {
		return JSON.parse(sessionStorage.getItem("cms_userInfo")) || {};
	} catch (e) {
		return {};
	}
};

// Identity is seeded synchronously from sessionStorage (per tab) so screens can
// fire their role-scoped requests on the very first render. Without this, every
// role-gated effect had to wait a full round-trip for /user/cms/status before it
// could even start - turning one wave of parallel calls into two sequential ones.
// The Sidebar still calls /user/cms/status on mount and overwrites these values,
// so the server stays authoritative; this only removes the dead wait.
// Only seeded when this tab is logged in, and cleared by logOutUser().
const initState = {
	isLoggedIn,
	role: (isLoggedIn && sessionStorage.getItem("cms_role")) || "",
	school_id: (isLoggedIn && sessionStorage.getItem("schoolId")) || "",
	teacher_id: (isLoggedIn && sessionStorage.getItem("teacherId")) || "",
	userInfo: parsedUserInfo(),
	isFromClassLink: false,
};

const Reducer = (state = initState, action) => {
	switch (action.type) {
		case ACTION_TYPES.LOGIN_USER:
			return {
				...state,
				isLoggedIn: true,
			};

		case ACTION_TYPES.LOGOUT_USER:
			return {
				...state,
				isLoggedIn: false,
				role: "",
				school_id: "",
				teacher_id: "",
			};

		case ACTION_TYPES.ROLE:
			return {
				...state,
				role: action.role,
			};
		case ACTION_TYPES.SCHOOL_ID:
			return {
				...state,
				school_id: action.school_id,
			};
		case ACTION_TYPES.TEACHER_ID:
			return {
				...state,
				teacher_id: action.teacher_id,
			};
		case ACTION_TYPES.USER_INFO:
			return {
				...state,
				userInfo: action.userInfo,
			};
		case ACTION_TYPES.CLASSLINK_USER:
			return {
				...state,
				isFromClassLink: action.isFromClassLink,
			};
		default:
			return state;
	}
};

export default Reducer;
